import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const MEDIA_BASE = `${BACKEND_URL}/api/public/media`;

// Public API: no credentials, no auth header
const publicApi = axios.create({
  baseURL: `${BACKEND_URL}/api/public`,
});

export function formatError(err, fallback = "Une erreur est survenue.") {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  if (d?.msg) return d.msg;
  return fallback;
}

export default publicApi;
